var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43366 8.53951L2.39082 13.5823C2.20214 13.771 1.96201 13.8654 1.67041 13.8654C1.37882 13.8654 1.13869 13.771 0.950009 13.5823C0.761331 13.3937 0.666992 13.1535 0.666992 12.8619C0.666992 12.5703 0.761331 12.3302 0.950009 12.1415L5.99285 7.0987L0.950009 2.05586C0.761331 1.86718 0.666992 1.62705 0.666992 1.33545C0.666992 1.04386 0.761331 0.803725 0.950009 0.615048C1.13869 0.42637 1.37882 0.332031 1.67041 0.332031C1.96201 0.332031 2.20214 0.42637 2.39082 0.615048L7.43366 5.65789L12.4765 0.615048C12.6652 0.42637 12.9053 0.332031 13.1969 0.332031C13.4885 0.332031 13.7286 0.42637 13.9173 0.615048C14.106 0.803725 14.2003 1.04386 14.2003 1.33545C14.2003 1.62705 14.106 1.86718 13.9173 2.05586L8.87447 7.0987L13.9173 12.1415C14.106 12.3302 14.2003 12.5703 14.2003 12.8619C14.2003 13.1535 14.106 13.3937 13.9173 13.5823C13.7286 13.771 13.4885 13.8654 13.1969 13.8654C12.9053 13.8654 12.6652 13.771 12.4765 13.5823L7.43366 8.53951Z",
    fill: "#E10505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.815df623f286846577d1cf8be6c5408f.svg";
export { ForwardRef as ReactComponent };